import { zSchema } from "../../../schema-validation";

export const addPaymentAccountSchema = zSchema.object({
  odo_user_id: zSchema.string(),
  perform_kyc: zSchema.boolean(),
});
